// Vue <Transition> hooks that animate an element's height between 0 and its
// natural content height, for enter/leave of elements whose content height
// isn't known ahead of time. Height is measured via scrollHeight at
// transition time and cleared again once the transition ends so it doesn't
// clip content that changes afterwards.
//
// Duration scales with that measured height rather than being one fixed
// value — a short panel (e.g. Calculated) and a tall one (Graph, Trajectory,
// up to 80vh) were both animating in the same fixed 0.2s, which for the tall
// ones is fast enough that the height change barely reads as motion: it
// looks like the content just gets cut off/appears rather than sliding.
const MIN_DURATION_MS = 200;
const MAX_DURATION_MS = 450;
const DURATION_PER_PX_MS = 0.35;

function durationMsFor(heightPx) {
  return Math.min(MAX_DURATION_MS, Math.max(MIN_DURATION_MS, heightPx * DURATION_PER_PX_MS));
}

export function useHeightTransition() {
  function beforeEnter(el) {
    el.style.height = '0';
    el.style.overflow = 'hidden';
  }
  function enter(el) {
    const targetHeight = el.scrollHeight;
    el.style.transition = `height ${durationMsFor(targetHeight)}ms ease`;
    requestAnimationFrame(() => {
      el.style.height = targetHeight + 'px';
    });
  }
  function afterEnter(el) {
    el.style.height = '';
    el.style.overflow = '';
    el.style.transition = '';
  }
  function beforeLeave(el) {
    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  }
  function leave(el) {
    const startHeight = el.scrollHeight;
    el.style.transition = `height ${durationMsFor(startHeight)}ms ease`;
    requestAnimationFrame(() => {
      el.style.height = '0';
    });
  }
  function afterLeave(el) {
    el.style.height = '';
    el.style.overflow = '';
    el.style.transition = '';
  }

  return { beforeEnter, enter, afterEnter, beforeLeave, leave, afterLeave };
}
